import React from 'react';
import { Phone } from 'lucide-react';
import { PhysicianAvatar, type PhysicianAvatarProps } from '~/libraries/physicians/PhysicianAvatar';
import { formatPhoneNumber } from '~/util/functions';
import { useQuery } from '@tanstack/react-query';
import { getAdmissionOptions, getFaceToFaceOptions } from '@generated';
import { Loading } from '~/shared/Loading';

export function AdditionalPhysicians({ stayId }: { stayId: string }) {
	const { data: admission, isLoading: referralIsLoading } = useQuery(getAdmissionOptions(stayId));
	const { data: f2f, isLoading: f2fIsLoading } = useQuery(getFaceToFaceOptions(stayId));

	const isLoding = referralIsLoading || f2fIsLoading;

	return (
		<div>
			<div className="mb-4 flex items-center justify-between">
				<div>
					<h2 className="text-sm font-semibold text-gray-800">Additional Physicians</h2>
					<p className="mt-0.5 text-xs text-gray-500">Referring, F2F, etc.</p>
				</div>
			</div>

			<div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
				{isLoding ? (
					<Loading />
				) : !admission ? (
					<div className="text-sm text-gray-500">No additional physician information available.</div>
				) : (
					<>
						{admission.referral.referringPhysician && (
							<AdditionalPhysicianCard {...admission.referral.referringPhysician} physicianLabel="Referring" />
						)}
						{f2f && f2f.faceToFacePhysician && <AdditionalPhysicianCard {...f2f.faceToFacePhysician} physicianLabel="F2F" />}
					</>
				)}
			</div>
		</div>
	);
}

export function AdditionalPhysicianCard(props: PhysicianAvatarProps & { phoneNumber: string }) {
	return (
		<div className="rounded-xl border border-gray-200 bg-white p-4 transition-all hover:border-gray-300 hover:shadow-sm">
			<div className="flex items-start justify-between gap-3">
				<PhysicianAvatar {...props} />
			</div>

			<div className="mt-2.5 flex items-center gap-1.5">
				<Phone size={11} className="shrink-0 text-gray-400" />
				<a href={`tel:${props.phoneNumber}`} className="text-xs text-gray-600 transition-colors hover:text-green-700">
					{formatPhoneNumber(props.phoneNumber)}
				</a>
			</div>
		</div>
	);
}
